import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { Settings } from "../../Settings";
import { EnumUserType } from "../enums/EnumUserType";
import { GlobalUser } from "../GlobalUser";
import { JsonMenuItem } from "../json-data-types/JsonMenuItem";
import { JsonProductCategory } from "../json-data-types/JsonProductCategory";
import { ServerCategories } from "../server-queries/ServerCategories";
import { ServerMenu } from "../server-queries/ServerMenu";
import { UrlGenerator } from "../UrlGenerator";
import { EnumIconNames } from "../enums/EnumIconNames";
import { Button } from "./form/Button";
import { ButtonIcon } from "./form/ButtonIcon";
import { Icon } from "./Icon";
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton";
import css from './MenuItem.m.scss'
import { MenuItemProductCategory } from "./MenuItemProductCategory";
import { MenuItemSimple } from "./MenuItemSimple";
import { SubMenu } from "./SubMenu";

interface Attrs{
    jsonMenuItem:JsonMenuItem
}

export class MenuItem extends DomeComponent<Attrs>{
    refContainer!:HTMLDivElement
    refMenuItemText!:HTMLDivElement
    refCounter!:HTMLSpanElement
    //refSubmenu?:HTMLDivElement
    refSubMenu!:SubMenu

    render(){
        return <div><LoadingSpinnerForButton /></div>
    }
    async afterRender(){
        if(await this.checkIfVisibleAsync(this.attrs.jsonMenuItem) === false) {
            await DomeManipulator.replaceAsync(this.rootElement, <></>)
            return 
        }

        let subItemsRendered:any[] = []
        if(this.attrs.jsonMenuItem.type === 'product-categories'){
            const subCategories = await ServerCategories.getTopLevelCategoriesAsync()    
            for(let subCategory of subCategories){
                subItemsRendered.push(<MenuItemProductCategory category={subCategory} />)
            }
        } else {
            const subItems = await ServerMenu.getSubItemsSortedAsync(this.attrs.jsonMenuItem.id)
            for(let subItem of subItems){
                subItemsRendered.push(<MenuItemSimple menuItem={subItem} />)
            }
        }
        //return <div>{JSON.stringify(this.attrs.jsonMenuItem)}</div>
        await DomeManipulator.replaceAsync(this.rootElement,
            <div ref={ref => this.refContainer = ref} class={css.menuItem}>
                <div ref={ref =>this.refMenuItemText = ref} class={css.menuItemText} onClick={() => this.onMenuItemClick() }>
                    <div>
                        <a href={Settings.addPrefixForUrl(this.attrs.jsonMenuItem.url)} 
                            onClick={(e) => this.onLinkClick(e)} 
                            class={css.topLevelLink}>
                                {this.attrs.jsonMenuItem.name}
                        </a>
                    </div>
                    <div class={css.counter} ref={ref => this.refCounter = ref}>{subItemsRendered.length > 0 
                        ? <>{subItemsRendered.length }<Icon iconName={EnumIconNames.RightOpen} /></>
                        : ''
                        }</div>
                </div>
                {subItemsRendered.length>0 &&
                    <SubMenu ref={ref => this.refSubMenu = ref}>
                        {subItemsRendered}
                    </SubMenu>
                }
            </div>
        )
    }

    protected onMenuItemClick(){
        if(this.refSubMenu){
            this.refSubMenu.show()
        } else {
            DomeRouter.navigate(Settings.addPrefixForUrl(this.attrs.jsonMenuItem.url))
        }
    }

    protected onLinkClick(e){
        e.preventDefault()
        //e.stopPropagation()

        // 
    }


    protected async checkIfVisibleAsync(jsonTopMenuItem:JsonMenuItem){
        const userType = await GlobalUser.getUserTypeAsync()
        return jsonTopMenuItem.visibleFor.indexOf(userType)>=0
    }


    protected async updateCounter(newCount:number){
        if(newCount>0){
            await DomeManipulator.replaceAllChildrenAsync(this.refCounter, <>{newCount}<Icon iconName={EnumIconNames.RightOpen} /></>)
        } else {
            await DomeManipulator.replaceAllChildrenAsync(this.refCounter, <></>)
        }
    }

    
    // async renderCategoryMenuItemAsync(category:JsonProductCategory){
    //     //if(!this.checkIfCategoryMenuItemIsVisible(category)) return null
    //     if(await ServerCategories.checkIfCurrentUserCanSeeCategoryAsync(category) === false) return null

    //     // get subCategories
    //     const subCategories = await ServerCategories.getAllSubcategoriesAsync(category.id)
    //     if(subCategories.length === 0){
    //         const url = UrlGenerator.productsByCategoryWithDefaultParameters(category)
    //         const link = (
    //                 <a href={url} onClick={(e) => {
    //                     e.preventDefault()
    //                     e.stopPropagation()
    //                     DomeRouter.navigate(url)
    //                 }}>
    //                     {category.name}
    //                     {/* <span class={css.counter}>{attrs.category.countOfProducts}</span> */}
    //                 </a>
    //         )
    //         if(category.nameHtml && category.nameHtml.length>2){
    //             link.innerHTML = category.nameHtml
    //         }
    //         return <div class={css.productCategoryMenuItem}>{link}</div>
    //     }

    //     // have subCategories
    //     return (
    //         <div class={css.productCategoryMenuItem} ref={ref => {
    //             if(category.nameHtml && category.nameHtml.length>2){
    //                 ref.innerHTML = category.nameHtml
    //             } else {
    //                 ref.innerHTML = category.name
    //             }
    //         }}>

    //         </div>
    //     )

    // }





}